import { render, staticRenderFns } from "./RecoverPasswordPage.vue?vue&type=template&id=26b1be63&"
import script from "./RecoverPasswordPage.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports